import { FormattedMessage, useIntl } from 'react-intl';

import type { JobFilterLocation } from '@xing-com/crate-common-graphql-types';
import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  SEARCH_STATE_DISABLED_FILTER_PARAMS,
  SEARCH_STATE_SEPARATOR,
} from '@xing-com/crate-jobs-constants';

import { Tag } from '../applied-filters.styles';

type Props = {
  option: JobFilterLocation & { isExtracted?: boolean };
};

export const ExtractedLocationTag: React.FC<Props> = ({ option }) => {
  const { formatMessage } = useIntl();
  const { getSearchParameter, setSearchParameter } = useSearchParameter();

  const location = option.location?.localizationValue;
  const radius = option.location?.radius;

  if (!location) return null;

  const handleOnExtractedLocation = (): void => {
    if (option.isExtracted) {
      const disabledParamName = SEARCH_STATE_DISABLED_FILTER_PARAMS.location;
      const current = getSearchParameter(disabledParamName);

      if (!current) {
        setSearchParameter(disabledParamName, location, { replace: false });
      } else {
        const values = new Set(current.split(SEARCH_STATE_SEPARATOR));

        if (values.has(location)) {
          return;
        }

        values.add(location);
        setSearchParameter(
          disabledParamName,
          [...values].join(SEARCH_STATE_SEPARATOR),
          {
            replace: false,
          }
        );
      }
    }
  };

  const ariaLabel = formatMessage(
    { id: 'JOBS_SEARCH_FILTERS_DELETE_FILTER_A11Y' },
    {
      variable_1: `${formatMessage({
        id: 'JOBS_SEARCH_FILTER_LOCATION_TEXT',
      })} ${location}`,
    }
  );

  return (
    <Tag onClick={handleOnExtractedLocation} aria-label={ariaLabel}>
      <FormattedMessage id="JOBS_SEARCH_FILTER_LOCATION_TEXT" />
      {` ${location}${radius ? ` (${radius} km)` : ''}`}
    </Tag>
  );
};
